<svg class="bi" [attr.height]="size" [attr.width]="size" fill="currentColor">
    <use [attr.xlink:href]="linkIcon"/>
</svg>
